export const ANCILLARY_SUB_PATH = "assets/ancillary"; // sub path to ancillary data in blob storage
export const ASSETS_API_PREFIX = "/api/assets"; // internal path to Next.js backend route
export const EMBEDDED_SUB_PATH = "assets/embedded"; // sub path to images in blob storage

export function getAncillaryAsset(key: string, assetPath: string) {
    const formattedImagePath = assetPath.replace(/\\/g, "/");
    return `${ASSETS_API_PREFIX}/${key}/${ANCILLARY_SUB_PATH}/${formattedImagePath}`;
}
